import { render, staticRenderFns } from "./saboHelpBox.vue?vue&type=template&id=6b9d0456&"
import script from "./saboHelpBox.vue?vue&type=script&lang=js&"
export * from "./saboHelpBox.vue?vue&type=script&lang=js&"
import style0 from "./saboHelpBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\TeamCity\\buildAgent\\work\\d66fd695757ba5a4\\src\\SABONyproduktion.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6b9d0456', component.options)
    } else {
      api.reload('6b9d0456', component.options)
    }
    module.hot.accept("./saboHelpBox.vue?vue&type=template&id=6b9d0456&", function () {
      api.rerender('6b9d0456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/houseModel/components/saboHelpBox.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/components/saboHelpBox.vue
// module id = 163
// module chunks = 0